const SVG_DATA_URL_PREFIX = "data:image/svg+xml";

function decodeSvgDataUrl(dataUrl) {
    if (typeof dataUrl !== "string" || !dataUrl.startsWith(SVG_DATA_URL_PREFIX)) return "";

    const commaIndex = dataUrl.indexOf(",");
    if (commaIndex === -1) return "";

    const metadata = dataUrl.slice(0, commaIndex).toLowerCase();
    const payload = dataUrl.slice(commaIndex + 1);

    try {
        if (metadata.includes(";base64")) {
            return atob(payload);
        }
        return decodeURIComponent(payload);
    } catch (error) {
        return "";
    }
}

function readBlobAsDataUrl(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

function loadImage(src) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
    });
}

async function rasterizeSvgSourceToImage(source) {
    try {
        const image = await loadImage(source);
        const width = Math.max(1, Math.round(image.naturalWidth || image.width || 374));
        const height = Math.max(1, Math.round(image.naturalHeight || image.height || 260));
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d");
        if (!context) return null;
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);
        return canvas.toDataURL("image/png");
    } catch (error) {
        return null;
    }
}

export async function resolvePdfGraphic(source) {
    if (!source || typeof source !== "string") return null;

    if (source.startsWith(SVG_DATA_URL_PREFIX)) {
        const image = await rasterizeSvgSourceToImage(source);
        if (image) return { image };

        const svg = decodeSvgDataUrl(source);
        return svg ? { svg } : null;
    }

    if (source.startsWith("data:")) {
        return { image: source };
    }

    try {
        const response = await fetch(source);
        const blob = await response.blob();

        if (blob.type === "image/svg+xml") {
            const svgDataUrl = await readBlobAsDataUrl(blob);
            const image = await rasterizeSvgSourceToImage(svgDataUrl);
            if (image) return { image };

            const svg = await blob.text();
            return svg ? { svg } : null;
        }

        const image = await readBlobAsDataUrl(blob);
        return image ? { image } : null;
    } catch (error) {
        return null;
    }
}
